/**
 * Created by PhpStorm on 08.05.2017.
 * Author: Shabalin Pavel
 * Email: aisamiery@gmail.com
 */
'use strict';

require('../modules/forms/forms');
require('../helpers/show-modal-message/show-modal-message');

angular.module('far.forms.subclubEditForm', ['dekky.forms', 'far.helpers.showModalMessage'])
    .service('subclubEditForm', function(form, autocomplete, showModalMessage) {

        var subclubForm = form('sub-club');

        subclubForm.autoCompleteSelect = {
            country: null,
            region: null,
            city: null,
            organization: null
        };

        subclubForm
            .addField('name', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Название клуба'
                }
            })
            .addField('club', 'uiSelect', {
                validators: {
                    required: false
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-650'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Федерация альпинизма',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Club", "club")',
                        refreshDelay: 0
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function( item ) {
                        if ( item ) {
                            subclubForm.autoCompleteSelect.organization = item.id;
                        }
                    }
                }
            }, autocomplete.get('club'))
            .addField('country', 'uiSelect', {
                validators: {
                    required: false
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-650'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Страна',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Country", "country")',
                        refreshDelay: 400
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete,
                    onSelect: function( item ) {
                        if ( item ) {
                            subclubForm.autoCompleteSelect.country = item.id;
                            subclubForm.autoCompleteSelect.region = null;
                            subclubForm.autoCompleteSelect.city = null;

                            subclubForm.$fields.region.items = [];
                            subclubForm.$fields.city.items = [];
                        }
                    }
                }
            }, autocomplete.get('country'))
            .addField('region', 'uiSelect', {
                validators: {
                    required: false
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-650'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Регион',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "KladrRegion", "region")',
                        refreshDelay: 400
                    },
                    refreshAutoComplete: function(name, term, object) {
                        return autocomplete.refreshAutoComplete(name, term, object, subclubForm.autoCompleteSelect)
                    },
                    onSelect: function( item ) {
                        if ( item ) {
                            subclubForm.autoCompleteSelect.region = item.id;
                            subclubForm.$fields.city.items = [];
                        }
                    }
                }
            }, autocomplete.get('region'))
            .addField('city', 'uiSelect', {
                validators: {
                    required: false
                },
                options: {
                    onSelect: 'field.uiSelectOptions.onSelect($item, $model)',
                    class: 'form__ui-select width-650'
                },
                uiSelectOptions: {
                    matchTitle: '{{ $select.selected.name }} ',
                    choicesTitle: '{{ item.name }}',
                    match: {
                        placeholder: 'Населенный пункт',
                        allowClear: true
                    },
                    choices: {
                        repeat: 'item in field.items track by item.id',
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "KladrCity", "city")',
                        refreshDelay: 400
                    },
                    refreshAutoComplete: function(name, term, object) {
                        return autocomplete.refreshAutoComplete(name, term, object, subclubForm.autoCompleteSelect)
                    }
                }
            }, autocomplete.get('city'))
            .addField('address', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Адрес'
                }
            })
            .addField('phone', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Телефон'
                }
            })
            .addField('email', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'E-mail'
                }
            })
            .addField('www', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Сайт'
                }
            })
            .addField('user', 'userSelect', {
                validators: {
                    required: true
                },
                uiSelectOptions: {
                    match: {
                        placeholder: 'Имя и фамилия руководителя'
                    }
                }
            }, autocomplete.get('users'))
            .addField('avatar', 'imageUpload', {
                validators: {
                    required: false
                },
                uploader: {
                    url: Routing.generate('api_upload_post_avatar', {thumb: 'avatar_relative'}),
                    autoUpload: true,
                    removeAfterUpload: true,
                    onWhenAddingFileFailed: function(item, filter) {
                        var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
                        showModalMessage(message);
                    },
                    onErrorItem: function() {
                        showModalMessage('Невозможно загрузить файл на сервер');
                    }
                }
            })
            .addField('social_vk', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Вконтакте'
                }
            })
            .addField('social_fb', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Facebook'
                }
            })
            .addField('social_in', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Instagram'
                }
            });

        return subclubForm;
});